<script lang="ts">
  import { api } from '$lib/erar/api';
  import type ERAR from '$lib/erar/spec';
  import MatchDetailsContent from './match-details-content.svelte';

  export let match: ERAR.Schema.MatchParticipation;

  let fetchParticipants = api('GET /participants/by-match/[id]', { params: { id: match.matchId } });
</script>

{#await fetchParticipants}
  <div class="skeleton">
    <div class="team">
      <div class="player" />
      <div class="player" />
      <div class="player" />
    </div>
    <div class="team">
      <div class="player" />
      <div class="player" />
      <div class="player" />
    </div>
  </div>
{:then participants}
  <MatchDetailsContent {match} {participants} />
{/await}

<style lang="postcss">
  .skeleton {
    background-color: var(--elevation-1);
    display: flex;
    flex-direction: column;
    > div {
      display: flex;
      flex-direction: column;
      background-color: var(--elevation-2);
      margin: var(--space-3);
      border-radius: var(--radius-2);

      > div {
        background-color: var(--elevation-3);
        margin: var(--space-3);
        border-radius: var(--radius-2);
        height: 13rem;
      }
    }
  }
</style>
